import axios from "axios";
import config from "../config";
import { toaster } from "../utils";
import store from "../store";
import { logout } from "../actions/authenticationAction";

const token = config.isSessionStorage
    ? sessionStorage.getItem("cpid")
    : localStorage.getItem("cpid");

const HTTP = axios.create({
    baseURL: config.baseURL,
    timeout: config.httpTimeout
});

export const unAuthHTTP = axios.create({
    baseURL: config.baseURL,
    timeout: 1000 * 60 //60 secs
});

HTTP.interceptors.request.use(
    async (config) => {
        if (token !== null && token !== undefined && token) {
            config.headers.Authorization = token ? `Bearer ${token}` : "";
            return config;
        }
        return config;
    },
    (err) => {
        return Promise.reject(err);
    }
);

HTTP.interceptors.response.use(
    (response) => {
        return response;
    },
    (err) => {
        // console.log(err.response.status);
        // if ([400].includes(err.response.status)) {
        //     toaster({
        //         status: "error",
        //         title: err?.response?.data?.error,
        //         message: err.response.data.message
        //     });
        // }
        // if ([417].includes(err.response.status)) {
        //     toaster({
        //         status: "warning",
        //         title: "",
        //         message: err.response.data.message
        //     });
        // }
        if ([410].includes(err.response.status)) {
            toaster({
                status: "error",
                title: "",
                message: err.response.data.message
            });
            store.dispatch(logout());
        }
        return Promise.reject(err);
    }
);

export default HTTP;
